
/**
 * 封装了localStorage 的相关方法
 * 用法: import localCache from "@/adapter/libs/localCache"
 *    写入缓存 localCache.set(key,value,time) key 为缓存的键，value 为缓存的value，time为缓存的有效时间，单位/秒
 *    读取缓存 localCache.get(key) key 为缓存的键
 *    移除缓存 localCache.remove(key) key 为缓存的键
 *    清空所有缓存  localCache.clear()   慎用，慎用
 */

var dtime = '_deadtime';
function set(k, v, t) {
  localStorage.setItem(k, JSON.stringify(v))
  var seconds = parseInt(t);
  if (seconds > 0) {
    var timestamp = Date.parse(new Date());
    timestamp = timestamp / 1000 + seconds;
    localStorage.setItem(k + dtime, timestamp + "")
  } else {
    localStorage.removeItem(k + dtime)
  }
}

function get(k, def) {
  var deadtime = parseInt(localStorage.getItem(k + dtime))
  if (deadtime) {
    if (parseInt(deadtime) < Date.parse(new Date()) / 1000) {
      if (def) { return def; } else { return null; }
    }
  }
  var res = localStorage.getItem(k);
  if (res) {
    return JSON.parse(res);
    //return (res);
  } else {
    return def;
  }
}

function remove(k) {
  localStorage.removeItem(k);
  localStorage.removeItem(k + dtime);
}

function clear() {
  localStorage.clear();
}
export default  {
  set: set,
  get: get,
  remove: remove,
  clear: clear,
}